import { inject, observer } from 'mobx-react'

import { DEFAULT_RETIREMENT_INCOME_GOAL_PCT } from '../../../models/Person'
import { incomeGoalTonePhrase } from '../../../utils'
import RetirementIncomeSection from './RetirementIncomeSection'
import OtherGoalsSection from './OtherGoalsSection'
import { PageContainer, PageTitle, PageTitleEmphasis } from './GoalsDashboardStyle'

const GoalsDashboard = ({ store }) => {
  const {
    config: { isSpendown, spendDownModeling },
    person,
  } = store

  const hasRetirementIncomeGoal = !isSpendown && !spendDownModeling
  const goalPercent = person?.retirementIncomeGoalPct ?? DEFAULT_RETIREMENT_INCOME_GOAL_PCT

  return (
    <PageContainer data-no-mobile-gutter>
      {/* Spend-down has no income replacement goal. */}
      {hasRetirementIncomeGoal ? (
        <PageTitle>
          You expect your costs in retirement to be{' '}
          <PageTitleEmphasis>{incomeGoalTonePhrase(goalPercent)}</PageTitleEmphasis>
        </PageTitle>
      ) : (
        <PageTitle>Your goals</PageTitle>
      )}

      {hasRetirementIncomeGoal && <RetirementIncomeSection />}
      <OtherGoalsSection />
    </PageContainer>
  )
}

export default inject('store')(observer(GoalsDashboard))
